import React, { useEffect, useState } from 'react';
import { ButtonsXP, HeaderXP, TitleXP, WrapperXP } from '../../layout/XPInterfaces';
import { CloseIcon, CollapseIcon, ExpandIcon } from './icon-components';
import { Button } from './styles-components';
import { beigeColor, blueMediumColor, redMediumColor } from '../../../styles/GlobalStyle';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface AlertProps {
	isVisible: boolean;
}

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
`

const Content = styled.div`
  height: 70px;
  background-color: ${beigeColor};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ButtonOk = styled.button`
  width: 90px;
  background-color: white;
  margin-top: 7px
`;

const Alert = ({ isVisible}: AlertProps) => {
	const { t } = useTranslation();
	const [alertIsOpen, setAlertIsOpen] = useState(true);

	useEffect(() => {
		if(isVisible)
			setAlertIsOpen(true);
	}, [isVisible])

	return (
		<Wrapper>
			<WrapperXP isVisible={isVisible && alertIsOpen}>
				<HeaderXP>
					<TitleXP>
						{t('Notification')}
					</TitleXP>
					<ButtonsXP>
						<Button color={blueMediumColor} disabled={true}><CollapseIcon/></Button>
						<Button color={blueMediumColor} disabled={true}><ExpandIcon/></Button>
						<Button color={redMediumColor} disabled={false} onClick={() => setAlertIsOpen(false)}><CloseIcon/></Button>
					</ButtonsXP>
				</HeaderXP>
				<Content>
					{t('TimeIsUpMessage')}
					<ButtonOk onClick={() => setAlertIsOpen(false)}>ОК</ButtonOk>
				</Content>
			</WrapperXP>
		</Wrapper>
	);
};

export default Alert;